import React from 'react';
import Main from './Main';
import LoginPage from './pages/loginPage/LoginPage';
import ForgotPassword from './pages/forgotPassword/ForgotPassword';
import ResetPassword from './pages/resetPassword/ResetPassword';
import RegistrationPage from './pages/registrationPage/RegistrationPage';
import Manager from './pages/manager/Manager';
import Player from './pages/player/Player';
import Screen from './pages/screen/Screen';
import StatisticsPage from './pages/statistics/StatisticsPage';
import ProtectedRoute from './components/protectedRoute/ProtectedRoute';
import EditorAsync from './pages/manager/pages/quizPage/editor/EditorAsync';
import QuizPlayersAsync from './pages/manager/pages/quizPage/players/QuizPlayersAsync';
import SettingsAsync from './pages/manager/pages/quizPage/settings/SettingsAsync';
import Info from './pages/manager/pages/quizPage/info/Info';
import CalendarEditorAsync from './pages/manager/pages/calendarPage/editor/CalendarEditorAsync';
import CalendarPlayersAsync from './pages/manager/pages/calendarPage/players/CalendarPlayerAsync';
import CalendarSettingsAsync from './pages/manager/pages/calendarPage/settings/CalendarSettingsAsync';
import CalendarStatistics from './pages/manager/pages/calendarPage/statistics/Statistics';
import LimitGame from './pages/infoPage/limitGame/LimitGame';
import QuizPlayerAsync from './pages/player/pages/quizPlayer/QuizPlayerAsync';
import ProfileAsync from './pages/manager/pages/setting/profile/ProfileAsync';
import SecurityAsync from './pages/manager/pages/setting/security/SecurityAsync';
import PermissionAsync from './pages/manager/pages/setting/permissions/PermissionAsync';
import TeamAsync from './pages/manager/pages/setting/teams/TeamAsync';
import DataManagementAsync from './pages/manager/pages/setting/dataManagement/DataManagementAsync';
import CalendarPlayerAsync from './pages/player/pages/calendarPlayer/CalendarPlayerAsync';
import { loadManagerComponent, mok } from './routesFetch';
import Page404 from './pages/page404/Page404';
import Page401 from './pages/page401/Page401';
import Wrapper from './pages/player/Wrapper';
import LeaderBoardAsync from './pages/leaderBoard/LeaderBoardAsync.jsx';


const routes = [
    {
        component: Main,
        routes: [
            {
                path: '/',
                exact: true,
                loadData: loadManagerComponent,
                component: ( { ...props } ) => <ProtectedRoute path='/' { ...props } component={ Manager }/>,
            },

            {
                path: '/404',
                restricted: false,
                component: Page404,
                loadData: mok,
            },

            {
                path: '/401',
                restricted: false,
                component: Page401,
                loadData: mok,
            },

            {
                path: '/dashboard',
                loadData: loadManagerComponent,
                component: ( { ...props } ) => <ProtectedRoute path='/' { ...props } component={ Manager }/>,
                routes: [

                    {
                        path: '/dashboard/tutorials',
                        loadData: loadManagerComponent,
                        component: ( { ...props } ) => <ProtectedRoute path='/' { ...props } component={ Manager }
                        />,
                        routes: [
                            {
                                path: '/dashboard/tutorials/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/dashboard/academy',
                        loadData: loadManagerComponent,
                        component: ( { ...props } ) => <ProtectedRoute path='/' { ...props } component={ Manager }
                        />,
                        routes: [
                            {
                                path: '/dashboard/academy/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/dashboard/perstests',
                        loadData: loadManagerComponent,
                        component: ( { ...props } ) => <ProtectedRoute path='/' { ...props } component={ Manager }
                        />,
                        routes: [
                            {
                                path: '/dashboard/perstests/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/dashboard/calendars',
                        loadData: loadManagerComponent,
                        component: ( { ...props } ) => <ProtectedRoute path='/' { ...props } component={ Manager }
                        />,
                        routes: [
                            {
                                path: '/dashboard/calendars/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },


                    {
                        path: '/dashboard/quizes',
                        loadData: loadManagerComponent,
                        component: ( { ...props } ) => <ProtectedRoute path='/' { ...props } component={ Manager }
                        />,
                        routes: [
                            {
                                path: '/dashboard/quizes/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/dashboard/*',
                        restricted: false,
                        component: Page404,
                        loadData: mok,
                    }
                ]
            },
            {
                path: '/quiz/:quizID',
                component: ( { ...props } ) => <ProtectedRoute path='/' { ...props }
                                                               component={ Manager }/>,
                loadData: mok,
                routes: [
                    {
                        path: '/quiz/:quizID/editor',
                        component: ( { ...props } ) => <EditorAsync props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/quiz/:quizID/editor/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/quiz/:quizID/players',
                        component: ( { ...props } ) => <QuizPlayersAsync props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/quiz/:quizID/players/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/quiz/:quizID/overview',
                        component: ( { ...props } ) => <Info props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/quiz/:quizID/overview/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/quiz/:quizID/question',
                        component: ( { ...props } ) => <StatisticsPage props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/quiz/:quizID/question/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/quiz/:quizID/statistics',
                        component: ( { ...props } ) => <StatisticsPage props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/quiz/:quizID/statistics/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/quiz/:quizID/settings',
                        component: ( { ...props } ) => <SettingsAsync props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/quiz/:quizID/settings/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/quiz/:quizID/*',
                        restricted: false,
                        component: Page404,
                        loadData: mok,
                    }

                ]
            },
            {
                path: '/person/:quizID',
                component: ( { ...props } ) => <ProtectedRoute path='/' { ...props }
                                                               component={ Manager }/>,
                loadData: mok,
                routes: [
                    {
                        path: '/person/:quizID/editor',
                        component: ( { ...props } ) => <EditorAsync props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/person/:quizID/editor/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/person/:quizID/players',
                        component: ( { ...props } ) => <QuizPlayersAsync props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/person/:quizID/players/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/person/:quizID/overview',
                        component: ( { ...props } ) => <Info props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/person/:quizID/overview/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/person/:quizID/question',
                        component: ( { ...props } ) => <StatisticsPage props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/person/:quizID/question/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/person/:quizID/statistics',
                        component: ( { ...props } ) => <StatisticsPage props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/person/:quizID/statistics/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/person/:quizID/settings',
                        component: ( { ...props } ) => <SettingsAsync props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/person/:quizID/settings/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/person/:quizID/*',
                        restricted: false,
                        component: Page404,
                        loadData: mok,
                    }

                ]
            },

            {
                path: '/academy/:quizID',
                component: ( { ...props } ) => <ProtectedRoute path='/' { ...props }
                                                               component={ Manager }/>,
                loadData: mok,
                routes: [
                    {
                        path: '/academy/:quizID/editor',
                        component: ( { ...props } ) => <EditorAsync props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/academy/:quizID/editor/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/academy/:quizID/players',
                        component: ( { ...props } ) => <QuizPlayersAsync props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/academy/:quizID/players/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/academy/:quizID/overview',
                        component: ( { ...props } ) => <Info props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/academy/:quizID/overview/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/academy/:quizID/question',
                        component: ( { ...props } ) => <StatisticsPage props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/academy/:quizID/question/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/academy/:quizID/statistics',
                        component: ( { ...props } ) => <StatisticsPage props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/academy/:quizID/statistics/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/academy/:quizID/settings',
                        component: ( { ...props } ) => <SettingsAsync props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/academy/:quizID/settings/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/academy/:quizID/*',
                        restricted: false,
                        component: Page404,
                        loadData: mok,
                    }

                ]
            },
            {
                path: '/calendar/:calendarID',
                component: ( { ...props } ) => <ProtectedRoute path='/' { ...props } component={ Manager }/>,
                routes: [
                    {
                        path: '/calendar/:calendarID/editor',
                        component: ( { ...props } ) => <CalendarEditorAsync props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/calendar/:calendarID/editor/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/calendar/:calendarID/players',
                        component: ( { ...props } ) => <CalendarPlayersAsync props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/calendar/:calendarID/players/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/calendar/:calendarID/statistics/overall',
                        component: CalendarStatistics,
                        loadData: mok,
                        routes: [
                            {
                                path: '/calendar/:calendarID/statistics/overall/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/calendar/:calendarID/statistics/country',
                        component: CalendarStatistics,
                        loadData: mok,
                        routes: [
                            {
                                path: '/calendar/:calendarID/statistics/country/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },
                    {
                        path: '/calendar/:calendarID/statistics/questions',
                        component: CalendarStatistics,
                        loadData: mok,
                        routes: [
                            {
                                path: '/calendar/:calendarID/statistics/questions/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/calendar/:calendarID/settings',
                        component: ( { ...props } ) => <CalendarSettingsAsync props={ { ...props } }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/calendar/:calendarID/settings/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },
                    {
                        path: '/calendar/:calendarID/*',
                        restricted: false,
                        component: Page404,
                        loadData: mok,
                    }

                ]
            },

            {
                path: '/login',
                component: LoginPage,
                loadData: mok,
            },

            {
                path: '/login/*',
                restricted: false,
                component: Page404,
                loadData: mok,
            },

            {
                path: '/forgot-password',
                component: ForgotPassword,
                loadData: mok,
            },

            {
                path: '/forgot-password/*',
                restricted: false,
                component: Page404,
                loadData: mok,
            },

            {
                path: '/reset-password/:token',
                component: ResetPassword,
                loadData: mok,
            },

            {
                path: '/reset-password/:token/*',
                restricted: false,
                component: Page404,
                loadData: mok,
            },

            {
                path: '/register',
                component: RegistrationPage,
                loadData: mok,
            },

            {
                path: '/register/*',
                restricted: false,
                component: Page404,
                loadData: mok,
            },
            {
                path: '/leaderboard',
                component: Player,
                loadData: mok,
                routes: [
                    {
                        path: '/leaderboard/quiz',
                        component: ( { ...props } ) => <Wrapper { ...props } />,
                        loadData: mok,
                        routes: [
                            {
                                path: '/leaderboard/quiz/:quizID',
                                component: ( { ...props } ) => <LeaderBoardAsync
                                    props={ { ...props } }/>,
                                loadData: mok,
                            },
                            {
                                path: '/leaderboard/quiz/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },

                        ]
                    },

                ]
            },

            {
                path: '/player',
                component: Player,
                loadData: mok,
                routes: [
                    {
                        path: '/player/quiz',
                        component: ( { ...props } ) => <Wrapper { ...props } quizType={ 'quiz' }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/player/quiz/:quizID',
                                component: ( { ...props } ) => <QuizPlayerAsync
                                    props={ { ...props, quizType: 'quiz' } }/>,
                                loadData: mok,
                            },
                            {
                                path: '/player/quiz/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },

                        ]
                    },

                    {
                        path: '/player/person',
                        component: ( { ...props } ) => <Wrapper { ...props } quizType={ 'person' }/>,
                        loadData: mok,

                        routes: [
                            {
                                path: '/player/person/:quizID',
                                component: ( { ...props } ) => <QuizPlayerAsync
                                    props={ { ...props, quizType: 'person' } }/>,
                                loadData: mok,
                            },
                            {
                                path: '/player/person/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/player/academy',
                        component: ( { ...props } ) => <Wrapper { ...props } quizType={ 'academy' }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/player/academy/:quizID',
                                component: ( { ...props } ) => <QuizPlayerAsync
                                    props={ { ...props, quizType: 'academy' } }/>,
                                loadData: mok,
                            },
                            {
                                path: '/player/academy/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/player/calendar',
                        component: ( { ...props } ) => <Wrapper { ...props } quizType={ 'calendar' }/>,
                        loadData: mok,
                        routes: [
                            {
                                path: '/player/calendar/:calendarID',
                                component: ( { ...props } ) => <CalendarPlayerAsync
                                    props={ { ...props, quizType: 'calendar' } }/>,
                                loadData: mok,
                            },
                            {
                                path: '/player/calendar/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },
                    {
                        path: '/player/limitgame',
                        component: LimitGame,
                        loadData: mok,
                        routes: [
                            {
                                path: '/player/limitgame/*',
                                restricted: false,
                                component: Page404,
                                loadData: mok,
                            },
                        ]
                    },

                    {
                        path: '/player/*',
                        restricted: false,
                        component: Page404,
                        loadData: mok,
                    }
                ]
            },
            {
                path: '/settings',
                component: ( { ...props } ) => <ProtectedRoute path='/' { ...props } component={ Manager }/>,
                loadData: mok,
                routes: [
                    {
                        path: '/settings/profile',
                        component: ( { ...props } ) => <ProfileAsync props={ { ...props } }/>,
                        loadData: mok
                    },
                    {
                        path: '/settings/security',
                        component: ( { ...props } ) => <SecurityAsync props={ { ...props } }/>,
                        loadData: mok
                    },
                    {
                        path: '/settings/teams',
                        component: ( { ...props } ) => <TeamAsync props={ { ...props } }/>,
                        loadData: mok
                    },
                    {
                        path: '/settings/permissions',
                        component: ( { ...props } ) => <PermissionAsync props={ { ...props } }/>,
                        loadData: mok
                    },
                    {
                        path: '/settings/data-management',
                        component: ( { ...props } ) => <DataManagementAsync props={ { ...props } }/>,
                        loadData: mok
                    },
                    {
                        path: '/settings/*',
                        restricted: false,
                        component: Page404,
                        loadData: mok,
                    }
                ]
            },
            {
                path: '/screen',
                component: Screen,
                loadData: mok,
            },

            {
                path: '/',
                component: StatisticsPage,
                loadData: mok,
            },

            {
                path: '/*',
                restricted: false,
                component: Page404,
                loadData: mok,
            }
        ]
    },

    {
        path: '*',
        restricted: false,
        component: Page404,
        loadData: mok,
    }
];

export default routes;